import React from 'react';
import { Check } from 'lucide-react';

const comparisonData = [
  {
    label: 'الباص',
    economic: '4 صفوف — 49 مقعداً',
    vip: '3 صفوف فاخرة — 30 مقعداً',
  },
  {
    label: 'الفندق',
    economic: '3 نجوم',
    vip: '4 أو 5 نجوم ★★★★★',
  },
  {
    label: 'الوجهة',
    economic: 'مكة أو مكة والمدينة',
    vip: 'مكة المكرمة',
  },
  {
    label: 'المدة',
    economic: '3 أو 5 أيام أو أكثر',
    vip: '3 أيام',
  },
  {
    label: 'السكن',
    economic: 'غرف خاصة أو مشتركة',
    vip: 'غرف خاصة أو مشتركة',
  },
];

export default function Comparison() {
  return (
    <section id="comparison" className="py-12 md:py-20 bg-gray-50">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-8 md:mb-12">
          <span className="inline-block bg-navy-100 text-navy-700 px-4 py-2 rounded-full text-sm font-cairo font-medium mb-4">
            مقارنة سريعة
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-amiri font-bold text-gray-900 mb-4">
            الاقتصادية أم VIP؟
          </h2>
          <p className="text-gray-600 font-cairo max-w-2xl mx-auto text-sm md:text-base">
            مقارنة تفصيلة بين باقات العمرة من الرياض — اختر ما يناسبك وميزانيتك
          </p>
        </div>

        {/* Comparison Table - Semantic HTML with Mobile Scroll */}
        <div className="bg-white rounded-2xl shadow-xl overflow-hidden overflow-x-auto">
          <table className="w-full border-collapse min-w-[500px]" role="table" aria-label="مقارنة باقات العمرة من الرياض">
            <caption className="sr-only">مقارنة تفصيلة بين الباقة الاقتصادية وباقة VIP للعمرة من الرياض</caption>
            <thead>
              <tr className="bg-brown-900 text-white">
                <th scope="col" className="p-3 md:p-6 font-cairo font-bold text-xs md:text-lg text-right">وجه المقارنة</th>
                <th scope="col" className="p-3 md:p-6 font-cairo font-bold text-xs md:text-lg text-center border-x border-brown-700">
                  <span className="text-brown-300">الاقتصادية</span>
                  <p className="text-xs text-gray-400 font-normal mt-1 hidden sm:block">يومياً تقريباً</p>
                </th>
                <th scope="col" className="p-3 md:p-6 font-cairo font-bold text-xs md:text-lg text-center">
                  <span className="text-gold-400">VIP</span>
                  <p className="text-xs text-gray-400 font-normal mt-1 hidden sm:block">الاثنين والخميس</p>
                </th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row, index) => (
                <tr
                  key={index}
                  className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'} border-t border-gray-100`}
                >
                  <th scope="row" className="p-3 md:p-5 font-cairo font-bold text-gray-900 text-right text-xs md:text-base">{row.label}</th>
                  <td className="p-3 md:p-5 font-cairo text-gray-700 text-center border-x border-gray-100 text-xs md:text-base">
                    <span className="inline-flex items-center gap-1 md:gap-2">
                      <Check className="w-3 h-3 md:w-4 md:h-4 text-brown-500 flex-shrink-0" />
                      {row.economic}
                    </span>
                  </td>
                  <td className="p-3 md:p-5 font-cairo text-gray-700 text-center text-xs md:text-base">
                    <span className="inline-flex items-center gap-1 md:gap-2">
                      <Check className="w-3 h-3 md:w-4 md:h-4 text-gold-500 flex-shrink-0" />
                      {row.vip}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
}
